export enum AuditTrailType {
  None,
  Create,
  Update,
  Delete,
}
